// Brand configuration for multi-brand support
// Currently configured for Resolute / Trade Print (FlightDeck)

export type BrandId = "resolute" | "craftyjet";

export interface BrandConfig {
  id: BrandId;
  name: string;
  logoSrc: string;
  primaryColor: string;
  accentColor?: string;
  tagline?: string;
}

// Current brand configuration (hard-coded to Resolute / Trade Print for now)
// In the future, this could be determined by domain, user selection, or database lookup
export const currentBrand: BrandConfig = {
  id: "resolute",
  name: "FlightDeck",
  logoSrc: "/brand/tradeprint-bird.png",
  primaryColor: "#3b82f6", // Blue primary
  accentColor: "#8b5cf6", // Purple accent
  tagline: "DTF Trade Print Portal",
};
